import { Locale } from '@enmon/commons';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/cs';
import '@formatjs/intl-pluralrules/locale-data/sk';

import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import '@formatjs/intl-relativetimeformat/locale-data/cs';
import '@formatjs/intl-relativetimeformat/locale-data/sk';

import enTranslationMessages from './translations/en.json';
import csTranslationMessages from './translations/cs.json';
import skTranslationMessages from './translations/sk.json';
import plTranslationMessages from './translations/pl.json';

export const DEFAULT_LOCALE = Locale.CS;

export const appLocales = [Locale.CS, Locale.EN, Locale.SK, Locale.PL];

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages) : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

export const translationMessages = {
  [Locale.EN]: formatTranslationMessages(Locale.EN, enTranslationMessages),
  [Locale.CS]: formatTranslationMessages(Locale.CS, csTranslationMessages),
  [Locale.SK]: formatTranslationMessages(Locale.SK, skTranslationMessages),
  [Locale.PL]: formatTranslationMessages(Locale.PL, plTranslationMessages),
};
